var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPedirVoz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#8894de;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(99 -26)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z",
    transform: "translate(-99 26)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-97 28)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,1A10,10,0,0,1,21,11v9.333a.667.667,0,0,1-.667.667H11A10,10,0,1,1,11,1Zm0,18.667h8.667V11A8.667,8.667,0,1,0,11,19.667Z",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(8.667 8.667)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(4.667 8.667)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(12.667 8.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedirVoz);
export default __webpack_public_path__ + "static/media/pedir-voz.3f2d44e454298a580561834064101bb5.svg";
export { ForwardRef as ReactComponent };